/* eslint-disable camelcase */
interface ReviewRaw {
  rating: number
  title: string
  rating_image_url: string
  text: string
  user: {
    username: string
  }
  published_date: string
  stay_date: string
  url: string
  management_responses?: Array<{
    date: string
    text: string
  }>
  verification_source: string
}

export interface ReviewsRawResponse {
  write_review?: string
  reviews?: ReviewRaw[]
  pagination?: {
    last: number
    page: number
    prev?: number
    next?: number
    total: number
  }
  property?: {
    source: string
  }
}

export const mapReview = (review: ReviewRaw) => ({
  stars: review.rating,
  title: review.title,
  starsImage: review.rating_image_url,
  text: review.text,
  author: review.user.username,
  publishedDate: review.published_date,
  stayDate: review.stay_date,
  readMore: review.url,
  verificationSource: review.verification_source,
  managementResponses:
    review.management_responses?.map(managementResponse => ({
      date: managementResponse.date,
      text: managementResponse.text,
    })) ?? [],
})

export const mapReviews = (data: ReviewsRawResponse) => {
  const reviews = data.reviews || []

  return {
    property: data.property ?? { source: '' },
    writeReview: data.write_review,
    reviews: reviews.map(mapReview),
    pagination: data.pagination ?? {
      last: undefined,
      page: 1,
      prev: undefined,
      next: undefined,
      total: undefined,
    },
  }
}
